export const toTitleCase = (value) =>
  String(value || "")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (s) => s.toUpperCase());

export const formatCell = (value) => {
  if (value === null || value === undefined || value === "") return "--";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "number") return String(value);
  if (typeof value === "string") return value;
  return JSON.stringify(value);
};

export const formatDateTime = (value) => {
  if (!value) return "--";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
};

export const getPrimaryArray = (payload, preferredKeys = []) => {
  if (Array.isArray(payload)) return payload;

  for (const key of preferredKeys) {
    if (Array.isArray(payload?.[key])) return payload[key];
  }

  if (payload && typeof payload === "object") {
    const arrayEntry = Object.values(payload).find(Array.isArray);
    if (arrayEntry) return arrayEntry;
  }

  return [];
};

export const getSecondaryArray = (
  payload,
  primaryKeySet = [],
  preferredKeys = []
) => {
  if (!payload || typeof payload !== "object") return [];

  for (const key of preferredKeys) {
    if (Array.isArray(payload[key])) return payload[key];
  }

  const allArrays = Object.entries(payload).filter(
    ([key, value]) => Array.isArray(value) && !primaryKeySet.includes(key)
  );
  return allArrays[0]?.[1] || [];
};

export const getSummaryEntries = (payload) => {
  if (!payload || typeof payload !== "object") return [];

  const source =
    payload.summary && typeof payload.summary === "object"
      ? payload.summary
      : payload;

  return Object.entries(source).filter(([, value]) => !Array.isArray(value));
};

export const normalizeListPayload = (payload) => {
  const items =
    (Array.isArray(payload) && payload) ||
    (Array.isArray(payload?.items) && payload.items) ||
    (Array.isArray(payload?.data) && payload.data) ||
    [];

  return {
    items,
    total:
      payload?.total_count ??
      payload?.total ??
      payload?.pagination?.total_count ??
      null,
  };
};

export const getFieldValue = (row, keys = []) => {
  if (!row || typeof row !== "object") return undefined;

  for (const key of keys) {
    const value = row[key];
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }

  return undefined;
};

